import React, { useEffect } from 'react';
import { pick } from 'ramda';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { DocumentGroup } from './components/DocumentGroup';
import * as hooks from './hooks';
import { IDENTT_MANUAL } from './constants';
import { useDynamicReducerSelector, withDynamicReducer } from './store';
import * as Types from './types';

export const IdenttBare: React.FC = () => {
    const translate = useComponentTranslations();
    const { showComponentMessage } = useComponentMethods();
    const { clientHost, documentGroups = [] } = useComponentConfig<Types.IIdenttManualComponentConfig>();
    const { isLoadingError } = useDynamicReducerSelector(pick(['isLoadingError']));

    hooks.useGetPlayerTags();

    useEffect(() => {
        if (isLoadingError || !clientHost || !documentGroups.length) {
            showComponentMessage(translate('notAvailable'));
        }
    }, [isLoadingError, clientHost, documentGroups, showComponentMessage, translate]);

    return (
        <>
            {documentGroups.map((documentGroup, index) => (
                <DocumentGroup key={index} documentGroup={documentGroup} documentIndex={index + 1} />
            ))}
        </>
    );
};

export const IdenttManual = withComponent({
    isForLoggedIn: true,
    tkPrefix: 'playtech.mobile.identt-manual.'
})(withDynamicReducer()(IdenttBare));

componentService.registerPageComponents({ [IDENTT_MANUAL]: IdenttManual });
